/**
 * Converts a date to UTC start of day (00:00:00.000)
 * This preserves the calendar date regardless of local timezone
 *
 * @param date - The date to convert
 * @returns A new Date object set to the start of the day in UTC
 *
 * @example
 * const date = new Date('2025-10-27'); // Local date
 * const utcStart = startOfDayUTC(date);
 * // Returns: 2025-10-27T00:00:00.000Z (not affected by timezone)
 */
export const startOfDayUTC = (date: Date): Date => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
};

/**
 * Converts a date to UTC end of day (23:59:59.999)
 * This preserves the calendar date regardless of local timezone
 *
 * @param date - The date to convert
 * @returns A new Date object set to the end of the day in UTC
 *
 * @example
 * const date = new Date('2025-10-27'); // Local date
 * const utcEnd = endOfDayUTC(date);
 * // Returns: 2025-10-27T23:59:59.999Z (not affected by timezone)
 */
export const endOfDayUTC = (date: Date): Date => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
};

export const startOfMonthUTC = (date: Date): Date => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = 1;

  return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
};

export const endOfMonthUTC = (date: Date): Date => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = new Date(date.getFullYear(), month + 1, 0).getDate();

  return new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
};
